<template>
  <div id="app" class="app-panel" ref="AppPanel" @scroll="mainScroll">
    <div v-if="getTopShow()">
      <div class="head-panel">
        <Head :is-show.sync="isShowHeaderBg"></Head>
      </div>
    </div>
    <div v-if="getSwipeShow()">
      <div class="swipe-panel">
        <Swipe :is-show.sync="isShowSwipe"></Swipe>
      </div>
    </div>
    <div :style="getMiddleStyle()">
      <router-view :key="$route.fullPath"/>
    </div>
    <Bottom v-if="getBottomShow()"></Bottom>
    <div v-if="showBackPanel" class="back-panel" @click="gotoTop()">
      <div>
        <van-image
          width="30"
          height="30"
          lazy-load
          :src="backTopSrc"
        />
      </div>
      <div>{{$t('view.app.back')}}</div>
    </div>
  </div>
</template>

<script>
import Head from './components/Head.vue'
import Bottom from './components/Bottom.vue'
import Swipe from './components/Swipe.vue'

export default {
  name: 'AppView',
  components: {
    Head,
    Bottom,
    Swipe
  },
  watch: {
    $route(to, from) {
      this.gotoTop()
      if(to.fullPath === '/'){
        this.isShowSwipe = true
      }else{
        this.isShowSwipe = false
      }
    }
  },
  data() {
    return {
      isShowHeaderBg: false,
      isShowSwipe: true,
      topExcludeUrl: ['/login','/register','/forget','/404','/notification'],
      swipeIncludeUrl: ['/'],
      bottomExcludeUrl: ['/404'],
      backTopSrc: require('@/assets/top.png'),
      showBackPanel: false,
      isCall: true
    }
  },
  mounted(){
    this.setSearchInput(true)
    // this.setSearchBg(true)
  },
  methods: {    
    getTopShow(){
      return !this.topExcludeUrl.includes(this.$route.path)
    },
    getSwipeShow(){
      return this.swipeIncludeUrl.includes(this.$route.path)
    },
    getBottomShow(){
      return !this.bottomExcludeUrl.includes(this.$route.path)
    },
    getMiddleStyle(){
      // if(this.topExcludeUrl.includes(this.$route.path)){
      //   if(this.bottomExcludeUrl.includes(this.$route.path)){
      //     return 'middle-panel-noall'
      //   }else{
      //     return 'middle-panel-notop'
      //   }
      // }else{
      //   if(this.bottomExcludeUrl.includes(this.$route.path)){
      //     return 'middle-panel-nobottom'
      //   }else{
      //     return 'middle-panel'
      //   }
      // }
      let height = 0
      if(this.getTopShow()){
        height += 104
      }
      if(this.getSwipeShow()){
        height += 300
      }
      if(this.getBottomShow()){
        height += 158
      }
      return {
        minHeight: 'calc(100vh - ' + height + 'px)'
      }
      
    },
    mainScroll(e) {
      if (e.target.scrollTop > 50) {
        // this.isShowHeaderBg = true
        this.showBackPanel = true
        // this.setSearchBg(true)
        // this.setSearchInput(true)
      } else {
        // this.isShowHeaderBg = false
        this.showBackPanel = false
        // this.setSearchBg(false)
        // this.setSearchInput(false)
      }
      const { scrollTop, clientHeight, scrollHeight } = e.target
      if (scrollTop + clientHeight >= scrollHeight - 188) {
        if(this.isCall){
          this.$root.$emit('get-bottom')
          this.isCall = false
        }
      }else if(scrollTop + clientHeight < scrollHeight - 388 ){
        if(!this.isCall){
          this.isCall = true
        }
      }
    },
    // initSearchInput(){
    //   let inputs = document.getElementsByClassName('van-field__control')
    //   if(inputs.length > 0){
    //     let input = inputs[0]
    //     if(input && !input.classList.contains('search-input')){
    //       input.classList.add('search-input')
    //     }
    //   }
    // },
    setSearchInput(isAdd){
      let inputs = document.getElementsByClassName('van-field__control')
      if(inputs.length > 0){
        let input = inputs[0]
        if(isAdd){
          if(input && input.classList.contains('search-input')){
            input.classList.remove('search-input')
          }
        }else{
          if(input && !input.classList.contains('search-input')){
            input.classList.add('search-input')
          }
        }
      }
    },
    // setSearchBg(isAdd){
    //   let elements = document.getElementsByClassName('app-search-icon')
    //   if(elements.length > 0){
    //     let el = elements[0]
    //     let firstDiv = Array.from(el.children).find(
    //       child => child.tagName === 'DIV'
    //     )
    //     firstDiv.classList.add('van-search-new-content')
    //     if(isAdd){
    //       if(firstDiv && !firstDiv.classList.contains('van-search-new-content')){
    //         firstDiv.classList.add('van-search-new-content')
    //       }
    //     }else{
    //       if(firstDiv && firstDiv.classList.contains('van-search-new-content')){
    //         firstDiv.classList.remove('van-search-new-content')
    //       }
    //     }
    //   }
    // },
    gotoTop(){
      this.$refs.AppPanel.scrollTop = 0
    }
  }
}
</script>

<style>
.app-panel {
  overflow-y: auto;
  height: 100vh;
  background: #f6f6f6;
}
.middle-panel-noall{
  min-height: 100vh;
}
.back-panel{
  position: fixed;
  top: calc(100vh - 50px - 50px);
  left: calc(100vw - 50px - 10px);
  background-color: rgba(40, 40, 40, 0.4);
  color:#fff;
  width: 50px;
  height: 50px;
}
.back-panel > div:nth-child(1){
  text-align: center;
}
.back-panel > div:nth-child(2){
  text-align: center;
  font-size: 12px;
}
.head-panel{
  height: 104px;
}
</style>